import { render } from "./turma_add_disciplina.vue?vue&type=template&id=7c4ed917&scoped=true"
import script from "./turma_add_disciplina.vue?vue&type=script&lang=js"
export * from "./turma_add_disciplina.vue?vue&type=script&lang=js"

import "./turma_add_disciplina.vue?vue&type=style&index=0&id=7c4ed917&lang=scss&scoped=true"
import "./turma_add_disciplina.vue?vue&type=style&index=1&id=7c4ed917&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4ed917"]])

export default __exports__